export default "__VITE_ASSET__68254f49__"